import { getLogger } from '../common/logging';

export class SumService {
  constructor() {
    this.items = [];
  }

  register(target, fieldName) {
    if (!this.items[target]) {
      this.items[target] = [];
    }

    if (this.items[target].indexOf(fieldName) < 0) {
      this.items[target].push(fieldName);
    }
  }

  getItems(target) {
    if (!this.items[target]) return [];
    return this.items[target];
  }
}
